<template>
  <nav class="navbar is-info is-fixed-top" v-if="hasAdminPriv">
    <div class="navbar-brand">
      <router-link to="/" class="navbar-item">
        <img src="../../assets/ansi-logo.png" /> HRIS
      </router-link>
      <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" onclick="document.querySelector('.navbar-menu').classList.toggle('is-active');">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div class="navbar-menu">
      <div class="navbar-start">

      </div>

      <div class="navbar-end" onclick="document.querySelector('.navbar-menu').classList.toggle('is-active');">
        <router-link v-show="!isHome" to="/" class="navbar-item text-size">Home</router-link>
        <router-link v-show="!isHome" :to="{name: 'Manage Branches'}" class="navbar-item text-size">Branch</router-link>
        <router-link v-show="!isHome" :to="{name: 'Manage Department'}" class="navbar-item text-size">Department</router-link>
        <router-link v-show="!isHome" :to="{name: 'Manage Job Title'}" class="navbar-item text-size">Job title</router-link>
        <router-link v-show="!isHome" :to="{name: 'List Of Employees'}" class="navbar-item text-size">Employee</router-link>
        <div class="navbar-item text-size has-dropdown is-hoverable" v-show="!isHome">
          <a class="navbar-link">
            Timesheet
          </a>

          <div class="navbar-dropdown">
            <router-link :to="{name: 'TimeSheet Module'}" class="navbar-item text-size">Timesheet</router-link>
            <router-link :to="{name: 'List Of TimeSheet for Modification'}" class="navbar-item text-size">Timesheet for modification</router-link>
          </div>
        </div>
        <router-link v-show="!isHome" :to="{name: 'List Of Leave'}" class="navbar-item text-size">Leave</router-link>
        <router-link v-show="!isHome" :to="{name: 'Manage Holiday'}" class="navbar-item text-size">Holidays</router-link>
        <div class="navbar-item text-size has-dropdown is-hoverable" v-show="!isHome">
          <a class="navbar-link">
            Payroll
          </a>

          <div class="navbar-dropdown">
            <router-link :to="{name: 'List Of Payrolls'}" class="navbar-item text-size">List</router-link>
            <router-link :to="{name: 'Create Payroll'}" class="navbar-item text-size">Create (single)</router-link>
            <router-link :to="{name: 'Create Bulk Payroll'}" class="navbar-item text-size">Create (bulk)</router-link>
          </div>
        </div>
        <div class="navbar-item text-size has-dropdown is-hoverable">
          <a class="navbar-link">
            13th Month Pay
          </a>

          <div class="navbar-dropdown">
            <router-link :to="{name: 'List Of 13 Month Pay'}" class="navbar-item text-size">List</router-link>
            <router-link :to="{name: 'Create Thirteen Month Pay'}" class="navbar-item text-size">Create (single)</router-link>
            <router-link :to="{name: 'Create Bulk 13th Month Pay'}" class="navbar-item text-size">Create (bulk)</router-link>
          </div>
        </div>
        <router-link v-show="!isHome" :to="{name: 'Report Module'}" class="navbar-item text-size">Report</router-link>
        <router-link v-show="!isHome" :to="{name: 'List Of Newsfeed'}" class="navbar-item text-size">Blog</router-link>
        <router-link v-show="!isHome" :to="{name: 'Document'}" class="navbar-item text-size">Document</router-link>
        <router-link v-show="!isHome" :to="{name: 'List of Users'}" class="navbar-item text-size">User Management</router-link>
        <div class="navbar-item">
          <div class="buttons text-size">
            <a class="button is-light" style="font-size:12px" @click="logoutUser">
              Log out
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<style>
.text-size {
  font-size: 12px;
}
</style>


<script>
import AuthService from '../../_services/auth'
import _ from 'lodash'

const authService = new AuthService()

export default {
  created() {
    this.checkIfItIsHome()
  },
  data() {
    return {
      isHome: true,
      hasAdminPriv: authService.hasAdminPriv()
    }
  },
  methods: {
    logoutUser() {
      localStorage.removeItem('token')
      this.$router.go('/login')
    },
    checkIfItIsHome() {
      if (this.$route.name === 'home') {
        this.isHome = true
      } else {
        this.isHome = false
      }
    }
  },
  watch: {
    $route(to, from) {
      this.checkIfItIsHome()
    }
  }
}
</script>
